import React,{useState, useEffect} from "react"
import { Link,useNavigate,useParams } from "react-router-dom";
import axios from "axios";
import { $ } from "react-jquery-plugin";
import { exhibitionlist, exhibitionview, officials } from "../../apis/urls";
import moment from "moment";
import ReactHtmlParser from 'react-html-parser';
import { decode } from "html-entities";
import { Loader } from "rsuite";




const ExhibitorView = () => {


    const [loader,setLoader] = useState(true);

    useEffect(() => {
        $('body').removeClass('sidebar-collapsed sidebar-active').addClass('');
        $('html,body').animate({ scrollTop: 0 }, 'fast');

        // setTimeout(() => {
            Listing();
            // });
    }, []);
    
    let navigate = useNavigate();

    const { id } = useParams();
    
    const [result, setResult] = useState({});
    
    const Listing = () => {
        
        let token = "Bearer "+localStorage.getItem('token');
        //console.log(token)
    
        const instance = axios.create({
            baseURL: `${exhibitionlist}/register/exhibitor/view/${id}`,
            timeout: 1000000,
            headers: {'authorization': token}
          });
    
          instance.get('').then(res => {
            setResult(res.data.data)  
            setLoader(false)
        });
    }



    return(
        <div>
        <aside class="right-side areas">    
            <div class="content-area dash-contentss">
                <div className="page-title-wrpr">
                        <div className="page-title-left-column">
                            
                            <h2 className="page-title">Exhibitor - {decode(result?.fname)} {decode(result?.lname)}</h2>
                        </div>                    
                    
                </div>
                <nav aria-label="breadcrumb">
                    <ol className="breadcrumb">
                    <li className="breadcrumb-item"><Link to="/dashboard">Home</Link></li>
                        <li className="breadcrumb-item"><Link to={"/exhibition"}>Exhibition</Link></li>
                        <li className="breadcrumb-item"><Link to={"/exhibition_register/"+result?.eid}>Exhibitors List</Link></li>
                        <li className="breadcrumb-item active" aria-current="page">Exhibition View</li>
                    </ol>
                </nav>


                {result && !loader &&
                <div class="event-details-wrprs" style={{margin:"auto", maxWidth:'100%'}}>
                    <div class="row">
                        <div class="col-md-12">
                            <div class="row event-basic-details-wrpr">
                                <div class="col-md-12 event-basic-details">

                                    <h2>{result?.organization}</h2>
                                    {ReactHtmlParser(decode(result?.description))}

                                    <hr style={{marginBottom:0}} />

                                    <div class="fees-wrpr">
                                        <div class="member-fee">
                                            <label>Name</label>
                                            <div class="fee-content" style={{fontSize:'14px'}}>
                                                {decode(result?.fname)} {decode(result?.lname)}
                                            </div>
                                        </div>
                                        <div class="member-fee">
                                            <label>Title</label>
                                            <div class="fee-content" style={{fontSize:'14px'}}>
                                                {result?.title}
                                            </div>
                                        </div>
                                        <div class="member-fee">
                                            <label>Email</label>
                                            <div class="fee-content" style={{fontSize:'14px'}}>
                                                {result?.email}
                                            </div>
                                        </div>
                                        <div class="member-fee">
                                            <label>Phone</label>
                                            <div class="fee-content" style={{fontSize:'14px', maxWidth:'300px'}}>
                                                {result?.phone}
                                            </div>
                                        </div>
                                        <div class="member-fee">
                                            <label>City</label>
                                            <div class="fee-content" style={{fontSize:'14px'}}>
                                                {result?.city}
                                            </div>
                                        </div>
                                        <div class="member-fee">
                                            <label>State</label>
                                            <div class="fee-content" style={{fontSize:'14px'}}>
                                                {result?.state}
                                            </div>
                                        </div>
                                    </div>

                                    <hr style={{marginBottom:0}} />


                                    <div class="fees-wrpr">
                                        <div class="member-fee">
                                            <label>No of Tables</label>
                                            <div class="fee-content" style={{fontSize:'14px'}}>
                                                {result?.table_num}
                                            </div>
                                        </div>
                                        <div class="member-fee">
                                            <label>Electricity</label>
                                            <div class="fee-content" style={{fontSize:'14px'}}>
                                                {result?.electricity}
                                            </div>
                                        </div>
                                        <div class="member-fee">
                                            <label>Payment Status</label>
                                            <div class="fee-content" style={{fontSize:'14px', color:result.payment === "PENDING"?'blue':'green'}}>
                                                <i className={result.payment === "PENDING"?"icon-hour-glass":"icon-checkmark4"} ></i> 
                                                &nbsp;&nbsp;
                                                {result?.payment}
                                            </div>
                                        </div>
                                        <div class="member-fee">
                                            <label>Payment Mode</label>
                                            <div class="fee-content" style={{fontSize:'14px', maxWidth:'300px', color:result.payment_type === "CHECK"?'blue':'green'}}>
                                            <i className={result.payment_type === "CHECK"?"icon-banknote":"icon-creditcards"} style={{fontSize:"18px"}}></i>
                                            &nbsp;&nbsp;{result.payment_type}
                                            </div>
                                        </div>
                                        <div class="member-fee">
                                            <label>Payment Details</label>
                                            <div class="fee-content" style={{fontSize:'14px'}}>
                                                {result?.payment_details}
                                            </div>
                                        </div>
                                        <div class="member-fee">
                                            <label>Amount</label>
                                            <div class="fee-content" style={{fontSize:'14px'}}>
                                                ${result?.amount    }
                                            </div>
                                        </div>
                                    </div>

                                    <hr style={{marginBottom:0}} />


                                    <div class="fees-wrpr">
                                    <div class="member-fee" style={{width:'30%'}}>
                                            <label>Mailing Address</label>
                                            <div class="fee-content" style={{fontSize:'14px'}}>
                                                {result?.mailaddress}
                                            </div>
                                        </div>
                                        <div class="member-fee"  style={{width:'5%'}}>
                                            <label></label>
                                            <div class="fee-content" style={{fontSize:'14px'}}>
                                                &nbsp;&nbsp;&nbsp;&nbsp;
                                            </div>
                                        </div>
                                        <div class="member-fee" style={{width:'30%'}}>
                                            <label>Comment</label>
                                            <div class="fee-content" style={{fontSize:'14px'}}>
                                                {result?.comments}
                                            </div>
                                        </div>
                                        <div class="member-fee"  style={{width:'5%'}}>
                                            <label></label>
                                            <div class="fee-content" style={{fontSize:'14px'}}>
                                                &nbsp;&nbsp;&nbsp;&nbsp;
                                            </div>
                                        </div>
                                        <div class="member-fee" style={{width:'30%'}}>
                                            <label>Previous Exhibition</label>
                                            <div class="fee-content" style={{fontSize:'14px'}}>
                                                {result?.previous_exhibition}
                                            </div>
                                        </div>
                                        {/* <div class="member-fee">
                                            <label></label>
                                            <div class="fee-content" style={{fontSize:'14px'}}>
                                                &nbsp;
                                            </div>
                                        </div> */}
                                    </div>

                                    <hr style={{marginBottom:0}} />

                                    <div className="list-action-wrpr showicons roundicons-text" style={{marginTop:'2%'}}>
                                        <div className="list-action-wrpr">

                                        <div style={{width:'10px'}} />
                                            <a 
                                                target="_blank" 
                                                href={`${result?.twitter}`} 
                                                style={{top:"-20px"}} 
                                                data-toggle="tooltip" 
                                                title="View" rel="noreferrer"
                                            >
                                                <i className="jobs icon-social-twitter" style={{background:'#1DA1F2'}}></i>
                                                <span>Twitter</span>
                                            </a>
                                            <div style={{width:'10px'}} />
                                            <a 
                                                target="_blank" 
                                                href={`${result?.fburl}`} 
                                                style={{top:"-20px"}} 
                                                data-toggle="tooltip" 
                                                title="View" rel="noreferrer"
                                            >
                                                <i className="jobs icon-social-facebook" style={{background:'#4267B2'}}></i>
                                                <span>Facebook</span>
                                            </a>
                                            <div style={{width:'10px'}} />
                                            <a 
                                                target="_blank" 
                                                href={`${result?.linkidinurl}`} 
                                                style={{top:"-20px"}} 
                                                data-toggle="tooltip" 
                                                title="View" rel="noreferrer"
                                            >
                                                <i className="jobs icon-social-linkedin" style={{background:'#0077B5'}}></i>
                                                <span>LinkedIn</span>
                                            </a>

                                        </div>
                                    </div>


                                </div>  
                            </div>
                        </div>
                    </div>
                </div>
                }

                {
                    loader &&
                    <div className="loader" style={{textAlign:'center', marginTop:'20%'}}>
                        <div className="spinner-border text-primary" role="status">
                            <span className="sr-only">Loading...</span>
                        </div>
                    </div>
                }

                {
                    !result && !loader &&
                    <div className="loader" style={{textAlign:'center', marginTop:'20%'}}>
                        <h3>No Data Found</h3>
                    </div>
                }


            </div>
        </aside>
    </div>
    )
}

export default ExhibitorView;